import React, { useState,useRef } from "react";
import {
  Card,
  Box,
  Heading,
  Button,
  CardHeader,
  CardBody,
  CardFooter,
  useDisclosure,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  FormControl,
  FormLabel,
  Input,
  DrawerFooter,
  Select,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Grid,
  Textarea,
} from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";


import { Cell, LedgerRow, RowActions, StatusMark } from "../../../components/ui";

function UserCard({ User, Update, Delete }) {
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenModal1,
    onOpen: onOpenModal1,
    onClose: onCloseModal1,
  } = useDisclosure();
  const {
    isOpen: isOpenEditApoi1,
    onOpen: onOpenEditApoi1,
    onClose: onCloseEditApoi1,
  } = useDisclosure();
  const initialRef = useRef(null);
  const [formData, setFormData] = useState({});
  const finalRef = useRef(null);

  // const [appointmentStatus, setAppointmentStatus] = useState("");
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "appointmentDate") {
      // Reformat the date value to "dd/mm/yyyy"
      const [year, month, day] = value.split("-");
      const formattedDate = `${day}/${month}/${year}`;

      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: formattedDate,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  
//on submit update missing

  return (
    <LedgerRow>
        <Cell full>
          <Text fontWeight={600}>{User.fname} {User.lname}</Text>
          <Text fontSize="sm" color="stone.500">{User.phone}</Text>
        </Cell>
        <Cell label="Scheduled">{User.appointmentDate}<Text fontSize="sm" color="stone.500">{User.appointmentTime ? User.appointmentTime : "00:00"}</Text></Cell>
        <Cell label="Submitted">{User.bookingDate}</Cell>
        <Cell label="Status"><StatusMark status={User.appointmentStatus} /></Cell>
        <Cell full>
          <RowActions>
            <Button variant="outline" size="sm" onClick={onOpenModal1}>View</Button>
            <Button as={Link} to={`/admin/usersDtails/${User.userId}`} variant="outline" size="sm">User</Button>
            <Button variant="outline" size="sm" onClick={onOpenEditApoi1}>Edit</Button>
            <Button variant="danger" size="sm" onClick={() => setIsDeleteAlertOpen(true)}>Delete</Button>
          </RowActions>
        </Cell>

      <AlertDialog
        isOpen={isDeleteAlertOpen}
        leastDestructiveRef={finalRef}
        onClose={() => setIsDeleteAlertOpen(false)}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Confirmation
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this Appointment?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button variant="ghost"
                ref={finalRef}
                onClick={() => setIsDeleteAlertOpen(false)}
              >
                Cancel
              </Button>
              <Button variant="dangerSolid"
                onClick={() => {
                  setIsDeleteAlertOpen(false);
                  Delete(User._id);
                }}
                ml={3}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <Drawer
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpenModal1}
        onClose={onCloseModal1}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
          >
            Appointment Details
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody pb={6}>
            <Grid
              templateColumns={{ base: "1fr", md: "1fr 1fr" }}
              gap={4}
            >
              <FormControl>
                <FormLabel>Full Name</FormLabel>
                <Box>{`${User.fname} ${User.lname ? User.lname : ""}`}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Mobile number</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {User.phone}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Box
                  name="fname"
                  ref={initialRef}
                  placeholder="First name"
                  // onChange={handleInputChange}
                  // value={formData.fname}
                >
                  {User.email}
                </Box>
              </FormControl>
              <FormControl>
                <FormLabel>Submitted Date</FormLabel>
                <Box>{User.bookingDate}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Appointment Status</FormLabel>
                <Box>{User.appointmentStatus}</Box>
              </FormControl>
              <FormControl>
                <FormLabel> Appointment Date</FormLabel>
                <Box>{User.appointmentDate}</Box>
              </FormControl>
              <FormControl>
                <FormLabel> Appointment Time</FormLabel>
                <Box>
                  {User.appointmentTime ? User.appointmentTime : "00:00"}
                </Box>
              </FormControl>

              <FormControl>
                <FormLabel>City</FormLabel>
                <Box>{User.city ? User.city : "Not recorded"}</Box>
              </FormControl>

              <FormControl>
                <FormLabel>Reference</FormLabel>
                <Box>{User.referedby ? User.referedby : "Not recorded"}</Box>
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Message</FormLabel>
                <Box>{User.message ? User.message : "Not recorded"}</Box>
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Author Message</FormLabel>
                <Box>{User.authorMessage ? User.authorMessage : "Not recorded"}</Box>
              </FormControl>
            </Grid>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Drawer
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpenEditApoi1}
        onClose={onCloseEditApoi1}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
          >
            Edit Appointment
          </DrawerHeader>
          <DrawerCloseButton />
          <DrawerBody pb={6}>
            <Grid
              templateColumns={{ base: "1fr", md: "1fr 1fr" }}
              gap={4}
            >
              <FormControl>
                <FormLabel>First name</FormLabel>
                <Input
                  name="fname"
                  ref={initialRef}
                  placeholder={User.fname}
                  onChange={handleInputChange}
                  value={formData.fname}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Last name</FormLabel>
                <Input
                  name="lname"
                  placeholder={User.lname}
                  onChange={handleInputChange}
                  value={formData.lname}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Date</FormLabel>
                <Input
                  type="date"
                  name="appointmentDate"
                  placeholder={User.appointmentDate}
                  onChange={handleInputChange}
                  min={new Date().toISOString().slice(0, 10)}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Time</FormLabel>
                <Input
                  type="time"
                  name="appointmentTime"
                  placeholder={User.appointmentTime}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input
                  name="email"
                  placeholder={User.email}
                  onChange={handleInputChange}
                  value={formData.email}
                />
              </FormControl>
              <FormControl>
                <FormLabel>City</FormLabel>
                <Input
                  name="city"
                  placeholder={User.city}
                  onChange={handleInputChange}
                  value={formData.city}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Reference</FormLabel>
                <Input
                  name="referedby"
                  defaultValue={User.referedby}
                  onChange={handleInputChange}
                  value={formData.referedby}
                />
              </FormControl>

              <FormControl
                gridColumn="1 / -1"
              >
                <FormLabel>Appointment Status</FormLabel>
                <Select
                  name="appointmentStatus"
                  value={formData.appointmentStatus || User.appointmentStatus}
                  onChange={handleInputChange}
                >
                  <option value="Pending">Pending</option>
                  <option value="Completed">Completed</option>
                </Select>
              </FormControl>
              <FormControl
                gridColumn="1 / -1"
                width="100%"
              >
                <FormLabel>Author Message</FormLabel>
                <Textarea
                rows={6}
                  width="100%"
                  defaultValue={User.authorMessage}
                  name="authorMessage"
                  onChange={handleInputChange}
                  value={formData.authorMessage}
                />
              </FormControl>
            </Grid>
          </DrawerBody>

          <DrawerFooter>
            <Button
              mr={3}
              onClick={() => {
                Update(formData, User._id);
                onCloseEditApoi1();
                setFormData({});
              }}
            >
              Save
            </Button>
            <Button variant="ghost"
              onClick={onCloseEditApoi1}
            >
              Cancel
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </LedgerRow>
  );
}

export default UserCard;
